import { render, staticRenderFns } from "./ActivityHospitalSalesByTendency.vue?vue&type=template&id=45f4927e&scoped=true&"
import script from "./ActivityHospitalSalesByTendency.vue?vue&type=script&lang=js&"
export * from "./ActivityHospitalSalesByTendency.vue?vue&type=script&lang=js&"
import style0 from "./ActivityHospitalSalesByTendency.vue?vue&type=style&index=0&id=45f4927e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f4927e",
  null
  
)

export default component.exports